export default "__VITE_ASSET__C1uJnw6X__"